<template>
  <div>
    <div class="animated fadeIn faster">
      <div class="row py-2 bg-darker justify-content-between">
        <div class="ml-2 ml-md-4 mw-70">
          <h3 class="mb-0"><i class="fas fas fa-heart"></i> Favorites</h3>
        </div>
        <div class="mr-2 mr-md-4 align-items-center">
          <button
            v-if="favList.length > 0"
            class="btn btn-danger btn-sm mr-1 mr-md-3"
            @click="removeAllBtn()"
          >
            <i class="fas fa-1x fa-trash"></i>
            <span class="d-none d-sm-inline-block">&nbsp;Clear</span> All
          </button>
          <router-link to="/">
            <i class="fas fa-2x fas fa-arrow-circle-left"></i>
          </router-link>
        </div>
      </div>
      <div class="row mt-4" v-if="favList.length == 0">
        <div class="col">
          <h2 class="text-center">No favorites yet.</h2>
        </div>
      </div>
      <div class="row mt-3 justify-content-center">
        <div
          class="col-12 my-2 px-4 animated fadeIn"
          v-for="(item, index) in favList"
          :key="item.id"
        >
          <div class="inner-item">
            <div class="row">
              <div class="col-sm-6 align-self-center product-image">
                <img
                  @click="
                    $emit('showImage', {
                      imageSelected: S3URL + item.imagePicked
                    })
                  "
                  class="img-fluid"
                  :src="S3URL + item.imagePicked"
                  data-toggle="modal"
                  data-target="#zoomImageModal"
                />
              </div>
              <div class="col-sm-6 text-left">
                <div class="product-info text-center">
                  <h3 class="title">{{ item.model }}</h3>
                  <hr class="my-0" />
                  <p>
                    <b>COLOR:</b>
                    {{ item.colorPicked }}
                  </p>

                  <p>
                    <b>FEATURES:</b>
                    <br />
                    <span v-html="item.features"></span>
                  </p>
                  <div class="row justify-content-center align-items-center">
                    <b>SIZES:</b>
                    <span
                      class="btn btn-sm rounded-circle border border-info ml-1"
                      v-for="size in item.sizes"
                      :key="size"
                      :class="[size===item.sizePicked ? 'btn-info' : 'btn-default']"
                    >
                      <input
                        :id="index + '-' + size"
                        class="d-none"
                        type="radio"
                        :value="size"
                        v-model="item.sizePicked"
                      />
                      <label :for="index + '-' + size" class="mb-0">{{
                        size.substring(0, 2)
                      }}</label>
                    </span>
                  </div>
                  <div class="row mx-auto justify-content-center">
                    <button
                      class="mx-1 btn btn-danger btn-sm btn-xs-block my-1"
                      @click="removeBtn(item.id)"
                    >
                      <i class="fa fa-trash" aria-hidden="true"></i> Remove
                      favorite
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmModal
      ref="singleFavoriteRemove"
      id="singleFavoriteRemove"
      @accept="remove()"
      >Are you sure you want to remove this item?</ConfirmModal
    >
    <ConfirmModal
      ref="removeAllFavorites"
      id="removeAllFavorites"
      @accept="removeAll()"
      >Are you sure you want to remove all favorites?</ConfirmModal
    >
  </div>
</template>

<script>
import ConfirmModal from "@/components/ConfirmModal.vue";

export default {
  name: "Favorites",
  components: { ConfirmModal },
  props: {
    favList: { type: Array, default: () => [] },
    S3URL: { type: String, default: "" }
  },
  data: function() {
    return {
      currentItem: "" // current item id selected for removal
    };
  },
  methods: {
    removeAllBtn() {
      this.$refs.removeAllFavorites.show();
    },
    removeAll() {
      this.$emit("removeAllFavorites");
    },
    removeBtn(itemId) {
      this.currentItem = itemId;
      this.$refs.singleFavoriteRemove.show();
    },
    remove() {
      this.$emit("removeFavorite", this.currentItem);
    }
  }
};
</script>
